namespace Matrix.Data {
    export interface ExtensionTableItem {
        DisplayName?: string;
        TableSchema?: string;
        Tablename?: string;
        FullName?: string;
    }
}
